import { OrderBy } from './common';

export type EquipmenId = string | number;

export type Prices = Record<EquipmenId, PriceEntry>;

export type PriceEntry = {
  equipmentId: EquipmenId;
  branchId?: string | number | null;
  companyId?: string | number | null;
  status: PriceStatus;
  dateTimeStamp: number;
  price?: Price;
};

export enum PriceStatus {
  INIT = 'INIT',
  LOADING = 'LOADING',
  ERROR = 'ERROR',
  COMPLETED = 'COMPLETED',
  PRICE_NOT_FOUND = 'PRICE_NOT_FOUND',
}

export type Price = {
  branch_id: number | null;
  company_id: number | null;
  equipment_class_id: EquipmenId;
  price_per_day?: number;
  price_per_week?: number;
  price_per_month?: number;
  rate_type_name?: string;
};

export enum PriceType {
  BRANCH = 'BRANCH',
  COMPANY = 'COMPANY',
  LOCATION = 'LOCATION',
}

export interface EquipmentClassList {
  equipment_classes: EquipmentClass[];
  pagination: Pagination;
}

export interface EquipmentClass {
  equipment_class_id: number;
  category_id: number;
  category_name: string;
  category_id_hierarchy: [string]
  category_name_hierarchy: [string]
  name: string;
  primary_image_url: string;
  slug: string;
}

export interface Pagination {
  has_more_items: boolean;
  object_count: number;
  page_count: number;
  page_number: number;
  page_size: number;
}

export type PriceQueue = {
  [key in string]: PriceCatalogIDComponent;
};

export interface FetchPriceRequestPayload {
  equipmentId: EquipmenId;
}

export interface FetchPricesFulfilledPayload {
  prices: Price[];
  companyId?: string | number | null;
}

export interface UpdatePriceCatalogPayload {
  equipmentIds: EquipmenId[];
  branchId: string | number | null;
  companyId: string | number | null;
}

export interface LoadingPricesActionPayload {
  equipmentIds: PriceCatalogIDComponent[];
}

export interface PriceCatalogIDComponent {
  equipmentId: EquipmenId;
  branchId?: string | number | null;
  companyId?: string | number | null;
}

export interface StartLoadingPricesPayload {
  list: PriceCatalogIDComponent[];
}

export enum EquipmentSortField {
  POPULARITY_ACROSS_CATEGORY = 'popularity-across-category',
  POPULARITY_IN_CATEGORY = 'popularity-in-category',
  EQUIPMENT_CLASS_NAME = 'equipment-class-name',
}

export type EquipmentSortBy = {
  [key in EquipmentSortField]?: OrderBy;
};
